﻿import Valg from '../../../Shared/Scripts/Models/Valg';

export interface ValgState {
    aVarighet?: Valg<string>;
    bBetale?: Valg<string>;
    cSkolepenger?: Valg<string>;
    cSkolepengerBelop?: number;
    visBetPlan: boolean
}

export const UPDATE_VALG = 'UPDATE_AVALG';

interface UpdateValgAction {
    type: typeof UPDATE_VALG;
    payload: Partial<ValgState>;
}

export type ValgStateActionTypes = UpdateValgAction;
